module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "bars",
      "classname": "w-8 h-8 text-white transform -rotate-90"
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": "menu"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": "side-menu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), (_vm.isLoading) ? _c('app-loading') : _c('router-view')], 1), _vm._v(" "), (_vm.user.id && _vm.user.lastPasswordUpdated != true) ? _c('modal-password-updated') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/FAVICON-2026.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d536080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Admin.vue
// module id = 454
// module chunks = 1